import React from 'react';
import Layout from "./layout/Layout";
import CalltoActionOne from "../elements/calltoaction/CalltoActionOne";
import SEO from "../common/SEO";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import PricingFive from "../elements/pricing/PricingFive";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import ServiceNine from "../elements/service/ServiceNine";




const WebDevelopment = () => {
    return (
        <>
            <SEO title="Web Development" />
            <Layout>
                <div className="main-content">
                    {/* Start Elements Area  */}
                    <div className="rwt-callto-action-area rn-section-gap">
                        <div className="wrapper">
                            <CalltoActionOne />
                        </div>
                    </div>
                    <Separator/>
                    <div className="rn-service-area rn-section-gap ">
                        <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mb--40">
                            <SectionTitle
                                textAlign = "text-center"
                                radiusRounded = "9"
                                title = "Increase the Efficiency of Your Processes with a Bespoke Web App!"
                                description = "The skilled staff at Mixon can provide a web solution to improve your company's speed, agility, efficiency, and scalability. Use our online applications to gain a competitive advantage over your competitors in business."
                            />
                        </div>
                    </div>
                    </div>
                    </div>
                    {/* End Elements Area  */}
                </div>
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    title = "What Mixon will Offer"
                                    description = ""
                                />
                            </div>
                        </div>
                        <ServiceNine
                            serviceStyle = "service__style--1 icon-circle-style with-working-process"
                            textAlign = "text-center"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator/>
                {/* Start Elements Area  */}
                <div className="rwt-pricing-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40 mb_sm--0">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = "Our Pricing"
                                    description = "The rates for our Web Design Services are listed below."
                                />
                            </div>
                        </div>
                        <PricingFive />
                    </div>
                </div>
                {/* End Elements Area  */}
                <CalltoActionThree/>
            </Layout>
        </>
    )
}

export default WebDevelopment;